import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuth, useOrganization } from '@clerk/clerk-react'

import { evalKeys } from '@/lib/queryKeys'
import type { UpdateEvalCaseInput } from '../types'
import { patchEvalCase } from '../api'

const NO_AUTH_TOKEN_ERROR = 'No authentication token available'

export function useUpdateEvalCaseMutation(caseId: string) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: UpdateEvalCaseInput) => {
      const token = await getToken()
      if (!token) throw new Error(NO_AUTH_TOKEN_ERROR)
      return patchEvalCase(token, caseId, input)
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: evalKeys.caseDetail(organization?.id, caseId),
      })
      void queryClient.invalidateQueries({
        queryKey: evalKeys.testCasesAll(organization?.id),
      })
    },
  })
}
